/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ApiKeyRevocationResult = {
    key: string;
    status: ApiKeyRevocationResult.status;
};
export namespace ApiKeyRevocationResult {
    export enum status {
        REVOKED = 'revoked',
        ALREADY_REVOKED = 'already_revoked',
        NOT_FOUND = 'not_found',
    }
}

